"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _IconErrorOutline = _interopRequireDefault(require("../../icons/General/IconErrorOutline"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _useHandleDimentions = _interopRequireDefault(require("./hooks/useHandleDimentions"));
var _Link = _interopRequireDefault(require("../Link"));
var _IconClose = _interopRequireDefault(require("../../icons/General/IconClose"));
var _useAutocomplete = _interopRequireDefault(require("./hooks/useAutocomplete"));
var _IconChevronDown = _interopRequireDefault(require("../../icons/General/IconChevronDown"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Autocomplete = /*#__PURE__*/_react.default.forwardRef(({
  height,
  css,
  ...props
}, ref) => {
  const valuesRef = /*#__PURE__*/(0, _react.createRef)();
  const {
    height: optionsHeight,
    dimentionsRef: optionsRef
  } = (0, _useHandleDimentions.default)();
  const {
    width: inputWrapperWidth,
    dimentionsRef: inputWrapperRef
  } = (0, _useHandleDimentions.default)();
  const {
    value,
    highlightedIndex,
    showValues,
    renderedValues,
    setShowValues,
    handleClear,
    handleOnInputClick,
    handleCustomOnKeyDown,
    handleOnKeyDown,
    handleValueClick,
    onInputChange,
    onFuzzyBlur,
    onFuzzyFocus
  } = (0, _useAutocomplete.default)(props);
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = valuesRef.current;
      if (node && node.contains(e.target)) return;
      setShowValues(false);
    };
    if (showValues) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showValues, valuesRef]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)("label", {
      ref: inputWrapperRef,
      onClick: props.onLabelClick ? e => e.preventDefault() : undefined,
      css: theme => [_styles.styles.default(theme), (props.invalid || props.invalidMessage) && _styles.styles.invalid(theme), props.validation && _styles.styles.validation, props.onLabelClick && _styles.styles.clickableLabel, height && _styles.styles.height(height), css && css],
      children: [(0, _jsxRuntime.jsxs)("span", {
        css: _styles.styles.label,
        children: [props.label && (props.onLabelClick ? (0, _jsxRuntime.jsx)(_Link.default, {
          textAlign: "left",
          removeUnderline: true,
          onClick: props.onLabelClick,
          children: props.label
        }) : (0, _jsxRuntime.jsx)("span", {
          children: props.label
        })), props.labelSecondary && props.labelSecondary]
      }), (0, _jsxRuntime.jsxs)("div", {
        css: theme => [_styles.styles.inputWrapper(theme)],
        children: [(0, _jsxRuntime.jsxs)("div", {
          css: _styles.styles.inputBox,
          children: [(0, _jsxRuntime.jsx)("input", {
            type: "text",
            placeholder: props.placeholder,
            value: value,
            disabled: props.disabled,
            autoFocus: props.focus,
            onBlur: props.fuzzy ? onFuzzyBlur : props.onBlur,
            onFocus: props.fuzzy ? onFuzzyFocus : props.onFocus,
            onChange: onInputChange,
            onKeyDown: props.onKeyDown ? handleCustomOnKeyDown : handleOnKeyDown,
            onClick: handleOnInputClick,
            ref: ref,
            name: props.name,
            autoComplete: "off",
            css: theme => [props.disabled && _styles.styles.disabled(theme)],
            children: _react.default.Children.map(props.children, child => child || null)
          }), props.clear && (0, _jsxRuntime.jsx)(_styles.Clear, {
            nostyle: true,
            onClick: handleClear,
            children: (0, _jsxRuntime.jsx)(_IconClose.default, {
              size: 14
            })
          }), props.loading && (0, _jsxRuntime.jsx)(_Spinner.default, {
            size: 14
          }), props.actions && (0, _jsxRuntime.jsx)("div", {
            children: props.actions
          }), props.chevron && (0, _jsxRuntime.jsx)(_IconChevronDown.default, {
            flipVertical: !!showValues,
            size: 12
          })]
        }), props.renderOptions && _react.default.Children.count(props.renderOptions) > 0 && (0, _jsxRuntime.jsx)("div", {
          ref: optionsRef,
          css: _styles.styles.inputValues,
          children: props.renderOptions
        })]
      }), props.invalidMessage && (0, _jsxRuntime.jsxs)("div", {
        css: _styles.styles.invalidMessage,
        children: [(0, _jsxRuntime.jsx)(_IconErrorOutline.default, {
          size: "16px"
        }), (0, _jsxRuntime.jsx)("span", {
          css: theme => [(0, _styles.ErrorMessage)(theme)],
          children: props.invalidMessage
        })]
      })]
    }), (Boolean(props.values?.length) || props.renderCustomValueInput) && !props.loading && showValues && (0, _jsxRuntime.jsxs)("div", {
      ref: valuesRef,
      css: () => [!props.renderCustomValueInput && _styles.styles.listWrapper(inputWrapperWidth), props.dynamicallyPlaceInput && Boolean(optionsHeight) && _styles.styles.listWrapperTopPosition(optionsHeight), props.dynamicallyPlaceInput && Boolean(optionsHeight) && props.invalidMessage && _styles.styles.listWrapperTopPosition(optionsHeight + 30), props.inputValuesMaxWidth && _styles.styles.listWrapperMaxWidth(props.inputValuesMaxWidth)],
      children: [Boolean(renderedValues?.length) && (0, _jsxRuntime.jsx)("ul", {
        css: theme => [_styles.styles.list(theme)],
        children: renderedValues.map((item, index) => {
          return (0, _jsxRuntime.jsx)("li", {
            tabIndex: 0,
            css: index === highlightedIndex ? _styles.styles.highlightedItem : null,
            onClick: () => handleValueClick(item),
            children: props.labelFromValues ? item[props.labelFromValues] : item.label
          }, props.keyFromValues ? item[props.keyFromValues] : item.key);
        })
      }), props.renderCustomValueInput && (0, _jsxRuntime.jsx)("div", {
        children: props.renderCustomValueInput
      })]
    })]
  });
});
var _default = exports.default = Autocomplete;